/**
 * To call: store.dispatch('addExample', '')
 */
const loadStorage = ({ commit }) => {
  commit('LOAD_STORAGE')
}

const addRunning = ({ commit }, sim) => {
  if (sim) {
    commit('ADD_RUNNING', sim)
  }
}

const removeRunning = ({ commit }, sim) => {
  if (sim) {
    commit('REMOVE_RUNNING', sim)
  }
}

const updateRunning = ({ commit }, sim) => {
  if (sim) {
    commit('UPDATE_RUNNING', sim)
  }
}

const setRunning = ({ commit }, sims) => {
  if (sims) {
    commit('SET_RUNNING', sims)
  }
}

const setHasSimulation = ({commit}, payload) => {
  commit('SET_HAS_SIMULATION', payload)
}

const setLoading = ({ commit }, payload) => {
  commit('SET_LOADING', payload)
}

// Deprecated
const updateHasSimulation = async ({commit}) => {
  // Removemos essa logica, todos podem simular.
  return true
  // const r = await con.get(simulador.has_simulation)
  // if (r.status === 200) {
  //   commit('SET_HAS_SIMULATION', r.value)
  // }
}

export { addRunning, loadStorage, removeRunning, updateRunning, setRunning, setHasSimulation, updateHasSimulation, setLoading }
